import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from 'kl-b2c-ui-kit';
import { useNavigate, useParams } from 'react-router-dom';
import { DefaultTheme, withTheme } from 'styled-components';
import { getApiService, getConfirmationApi, getStorageService } from 'services/api.factory';
import Success from 'components/common/Success';
import Error from 'components/common/Error';

const AgreementAccept: FC<{ theme: DefaultTheme }> = ({ theme }) => {
    const { t } = useTranslation('pages/home');

    const { agreementId } = useParams();
    const [agreementSuccess, setAgreementSuccess] = useState(false);
    const [agreementError, setAgreementError] = useState(false);

    const storageService = getStorageService();
    const apiService = getApiService(storageService);
    const confirmationService = getConfirmationApi(apiService);
    const navigate = useNavigate();

    useEffect(() => {
        if (!agreementId) return;
        confirmationService
            .confirmation(agreementId)
            .then(() => setAgreementSuccess(true))
            .catch(() => setAgreementError(true));
    });

    return (
        <Container>
            {agreementSuccess && (
                <Success
                    color={theme.palette.text.secondary}
                    gradient={theme.palette.green}
                    close={() => {
                        setAgreementSuccess(false);
                        navigate('/');
                    }}
                    gap={0}
                    title={t('agreement-success-title')}
                    text={t('agreement-success-text')}
                />
            )}
            {agreementError && (
                <Error
                    gap={0}
                    close={() => {
                        setAgreementError(false);
                        navigate('/');
                    }}
                    title={t('agreement-error-title')}
                    text={t('agreement-error-text')}
                />
            )}
        </Container>
    );
};

export default withTheme(AgreementAccept);
